import { DateTime } from "luxon"

import { ProductionDeliveryGroup, ProductionEditLine } from "./useProductionOrderEdit"

export type MergedDeliveryGroup = Readonly<{
    deliveryKey: string
    deliveryTime: DateTime
    lines: ProductionEditLine[]
    sourceKeys: string[]
}>

export function mergeGroupsByTime(groups: ReadonlyArray<ProductionDeliveryGroup>): MergedDeliveryGroup[] {
    const merged = new Map<
        string,
        { deliveryKey: string; deliveryTime: DateTime; lines: ProductionEditLine[]; sourceKeys: string[] }
    >()

    for (const group of groups) {
        const timeKey = group.deliveryTime.isValid ? (group.deliveryTime.toISO() ?? "invalid") : "invalid"
        const existing = merged.get(timeKey)
        if (existing) {
            existing.lines.push(...group.lines)
            existing.sourceKeys.push(group.deliveryKey)
        } else {
            merged.set(timeKey, {
                deliveryKey: timeKey,
                deliveryTime: group.deliveryTime,
                lines: [...group.lines],
                sourceKeys: [group.deliveryKey],
            })
        }
    }

    return Array.from(merged.values(), (group) => ({
        ...group,
        lines: [
            ...group.lines.filter((line) => !line.isExtraService),
            ...group.lines.filter((line) => line.isExtraService),
        ],
    }))
}
